export type TActivityStatus = 'notStarted' | 'inProgress' | 'ended';

export function getActivityStatus(currentTime: number, startTime: number, endTime: number): TActivityStatus {
    let status: TActivityStatus = 'notStarted';

    if (currentTime >= startTime && currentTime <= endTime) {
        status = 'inProgress';
    } else if (currentTime > endTime) {
        status = 'ended';
    }
    return status
}

type IFormatedDateObj = {
    date: string;
    time: string;
}

export function getFormatedTimeObj(time: number): IFormatedDateObj {
    const localeTimestamp = time * 1000; // 本地时间戳

    const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const date = new Date(localeTimestamp);  // 参数需要毫秒数，所以这里将秒数乘于 1000

    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return {
        date: `${monthList[date.getMonth()]}. ${date.getDate()}`,
        time: `${hours} ${ampm}`
    }
}
